<mat-tab-group>
  <mat-tab label="Profilo professionale">
    <div class="container" *ngIf="datiProfilo">
      <h1>{{datiProfilo.codiceProfilo}} - {{datiProfilo.nomeProfilo}}</h1>
      <div class="margin-bottom-20" *ngIf="datiProfilo.descrizioneProfilo">
        <p><strong>Descrizione profilo professionale</strong></p>
        <p>{{datiProfilo.descrizioneProfilo}}</p>
      </div>
      <div class="margin-bottom-20" *ngIf="datiProfilo.elementiContesto">
        <p><strong>Elementi di contesto</strong></p>
        <p>{{datiProfilo.elementiContesto}}</p>
      </div>
      <p class="margin-bottom-20" *ngIf="datiProfilo.livelloEqf"><strong>Livello EQF: {{datiProfilo.livelloEqf}}</strong></p>
      <h1>Classificazioni</h1>
      <div *ngIf="classificazioniAda" class="margin-bottom-20">
        <p class="width-100">
          <strong>ADA:</strong>
        </p>
        <mat-list>
          <mat-list-item *ngFor="let item of classificazioniAda">
            <strong>{{item.codiceAda}}</strong> - {{item.descrizione}}
          </mat-list-item>
        </mat-list>
      </div>
      <div *ngIf="classificazioniIstat" class="margin-bottom-20">
        <p class="width-100">
          <strong>Classificazione Nazionale delle Professioni ISTAT</strong>
        </p>
        <mat-list>
          <mat-list-item *ngFor="let item of classificazioniIstat">
            <strong>{{item.codiceIstat}}</strong> - {{item.nome}}
          </mat-list-item>
        </mat-list>
      </div>
      <div *ngIf="classificazioniAteco" class="margin-bottom-20">
        <p class="width-100">
          <strong>Classificazione Nazionale delle Attività economiche ATECO</strong>
        </p>
        <mat-list>
          <mat-list-item *ngFor="let item of classificazioniAteco">
            <strong>{{item.codiceAteco}}</strong> - {{item.descrizione}}
          </mat-list-item>
        </mat-list>
      </div>
      <div *ngIf="classificazioniIsco" class="margin-bottom-20">
        <p class="width-100">
          <strong>Classificazione Internazionale delle Professioni ISCO</strong>
        </p>
        <mat-list>
          <mat-list-item *ngFor="let item of classificazioniIsco">
            <strong>{{item.codiceIsco}}</strong> - {{item.descrizione}}
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Competenze di profilo">
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource">
        <!-- Position Column -->
        <ng-container matColumnDef="competenza">
          <th mat-header-cell *matHeaderCellDef> Competenza di profilo </th>
          <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="eqf">
          <th mat-header-cell *matHeaderCellDef> Livello EQF </th>
          <td mat-cell *matCellDef="let element"> {{element.eqfCompetenza}} </td>
        </ng-container>
        <!-- Digitale Column -->
        <ng-container matColumnDef="digitale">
          <th mat-header-cell *matHeaderCellDef> Digitale </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.digital" disabled></mat-checkbox>
          </td>
        </ng-container>
        <!-- Green Column -->
        <ng-container matColumnDef="green">
          <th mat-header-cell *matHeaderCellDef> Green </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.green" disabled></mat-checkbox>
          </td>
        </ng-container>
        <!-- Weight Column -->
        <ng-container matColumnDef="azioni">
          <th mat-header-cell *matHeaderCellDef> Azioni </th>
          <td mat-cell *matCellDef="let element">
            <mat-icon class="green" (click)="openDettaglioCompetenza(element)" matTooltip="Dettaglio Competenza">search</mat-icon>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSize]="10" showFirstLastButtons [length]="paginatorSize" aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </mat-tab>
</mat-tab-group>
